import CONSTANTS from '../constants';
import { alerts } from './alerts';
import PosService from '../services/posService';

export function fetchProducts(params, status = 'all') {
    return dispatch => {
        return PosService.getProducts(params, status).then((response) => {
            dispatch(productsAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Products not found'));
        });
    };

    function productsAction(products) { return {type: CONSTANTS.ACTIONS.POS.GET.PRODUCTS, products: products} }
}

export function fetchCategories(status = 'all') {
    return dispatch => {
        return PosService.getCategories(status).then((response) => {
            dispatch(categoriesAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Products not found'));
        });
    };

    function categoriesAction(categories) { return {type: CONSTANTS.ACTIONS.POS.GET.CATEGORIES, categories: categories} }
}

export function fetchPosOrder(orderId) {
    return dispatch => {
        return PosService.getOrder(orderId).then((response) => {
            dispatch(orderAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Order not found'));
        });

        function orderAction(order) { return {type: CONSTANTS.ACTIONS.POS.GET.ORDER, posOrder: order} }
    };
}

export function clearPosOrder() {
    return dispatch => {
        return dispatch(orderAction(null));
        function orderAction(order) { return {type: CONSTANTS.ACTIONS.POS.GET.ORDER, posOrder: order} }
    };
}

export function createPosOrder(params) {
    return dispatch => {
        dispatch({type: CONSTANTS.ACTIONS.SPINNER.SHOW});
        return PosService.createOrder(params).then((response) => {
            dispatch(alerts.success('Your order has been created successfully. Thank you for shopping with us.'));
            dispatch(orderAction(response.data));
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
        }).catch((error) => {
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
            dispatch(alerts.error(error.toString()));
        });
    };

    function orderAction(order) { return {type: CONSTANTS.ACTIONS.POS.CREATE.ORDER, posOrder: order} }
}

export function getPosConfig(siteId) {
    return dispatch => {
        dispatch({type: CONSTANTS.ACTIONS.SPINNER.SHOW});
        return PosService.getConfig(siteId).then((response) => {
            dispatch(configAction(response.data));
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
        }).catch((error) => {
            dispatch(alerts.error(error));
            dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
        });
    };

    function configAction(config) { return {type: CONSTANTS.ACTIONS.POS.GET.CONFIG, config: config} }
}



// WEBPACK FOOTER //
// ./src/actions/pos.js